<template>
	<div class="my-3">
		<ValidationObserver v-slot="{ invalid }" ref="observer">
			<b-form role="form">
				<b-row>
					<b-col cols="8">
						<b-form-group label="Total Other Income (Monthly)">
							<b-input-group v-if="isForeigIncome" size="md" prepend="RM">
								<b-form-input v-model="formattedTotalOtherIncome" type="text" disabled></b-form-input>
							</b-input-group>

							<b-form-input v-else v-model="formattedTotalOtherIncome" type="text"
								placeholder="Enter Total Rental Income (Monthly)" disabled></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>

				<el-table :data="others" style="width: 100%" cell-class-name="px-3">
					<el-table-column label="No." width="50" align="center">
						<template slot-scope="scope">{{ scope.$index + 1 }}</template>
					</el-table-column>
					<el-table-column label="Other Income Amount" width="200">
						<template slot-scope="{row}">
							<CurrencyInput v-model="row.amount" :options="currencyOptions" />
						</template>
					</el-table-column>
					<el-table-column label="Information" min-width="150">
						<template slot-scope="{row}">
							<b-form-input v-model="row.information"></b-form-input>
						</template>
					</el-table-column>
					<el-table-column label="Actions" min-width="100">
						<template slot-scope="{row}">
							<svg xmlns="http://www.w3.org/2000/svg" @click.prevent="removeOther(row)"
								class="text-danger cursor-pointer mx-2" width="20" height="20" viewBox="0 0 512 512">
								<path fill="currentColor"
									d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512zm-81-337c9.4-9.4 24.6-9.4 33.9 0l47 47l47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47l-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47l-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
							</svg>
						</template>
					</el-table-column>
				</el-table>
				<b-button @click="addOther" block variant="outline-primary" class="mt-3">+ Add</b-button>
				<!-- <b-row class="mt-4">
                    <b-col cols="4">
                        <b-button block variant="primary" @click.prevent="update()" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row> -->
			</b-form>
		</ValidationObserver>
	</div>
</template>

<script>
import { Button, Form, FormItem, Table, TableColumn, Select, Option } from 'element-ui'
import {
	notifyFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { EventBus } from '@/main'
import CurrencyInput from '@/components/CurrencyInput'

export default {
	props: ['customer', 'main_form'],
	components: {
		CurrencyInput,
		ValidationObserver,
		ValidationProvider,
		[Button.name]: Button,
		[Form.name]: Form,
		[FormItem.name]: FormItem,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	mixins: [
		notifyFunctionMixin,
	],
	data() {
		return {
			others: [],
			// isCurrencyConverted: false
		}
	},
	computed: {
		isForeigIncome() {
			// return false
			const wc = _gHlp.getValue(this.main_form, 'working_country');
			return !_gHlp.isEmpty(wc) && wc != 'Malaysia';
		},
		currencyRate() {
			return _gHlp.getValue(this.main_form, 'foreign_currency');
		},
		totalOtherIncome() {
			const total = this.others.reduce((acc, rental) => {
				const amount = parseFloat(rental.amount);
				return isNaN(amount) ? acc : acc + amount;
			}, 0);
			return total;
		},
		formattedTotalOtherIncome: {
			get() {
				return isNaN(this.totalOtherIncome) ? '0.00' : this.totalOtherIncome.toFixed(2);
			},
			set(newValue) {
			}
		},
		currencyOptions() {
			return {
				currency: 'MYR',
				currencyDisplay: this.isForeigIncome ? 'symbol' : 'hidden',
				autoDecimalDigits: true,
			};
		},
	},
	created() {
		EventBus.$on('collect-income-data', this.sendIncomeData);
	},
	watch: {
		customer: {
			handler: function (newValue) {
				if (!_gHlp.isEmpty(newValue)) {
					this.initData();
				}
			},
			immediate: true
		},
		main_form: {
			handler: function (newValue) {
				if (!_gHlp.isEmpty(newValue)) {
					this.initData();
				}
			},
			immediate: true
		},
	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomer']),
		initData() {
			this.others = _gHlp.getValue(this.customer, 'incomes.other', []);
			// if(this.isForeigIncome && !this.isCurrencyConverted){
			// 	this.others.forEach(el => {
			// 		el.amount = _gHlp.currencyFromRM(el.amount, this.currencyRate)
			// 	});
			// 	this.isCurrencyConverted = true;
			// }
		},
		setData() {
			let others = this.others.map((obj, index) => {
				return {
					...(obj.customer_other_income_id && { customer_other_income_id: obj.customer_other_income_id }),
					// amount: (this.isForeigIncome) ? _gHlp.currencyToRM(obj.amount, this.currencyRate) : obj.amount,
					amount: obj.amount,
					information: obj.information,
				}
			})

			let data = { others: others }
			return data
		},
		update() {
			let data = this.setData()
			axios.post(services.customer + 'customer/' + this.customer.customer_id + '/income/others', data, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>Monthly Other Income: ' + this.customer.name + '</b> - Successfully Updated.')
					this.getCustomer(this.customer.customer_id)
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		removeOther(item) {
			if (this.others.length > 0) {
				var index = this.others.indexOf(item);
				this.others.splice(index, 1);
			}
		},
		addOther() {
			this.others.push({
				customer_id: this.customer.customer_id,
				amount: null,
				information: null,
			});
		},
		sendIncomeData() {
			this.$emit('income-data-collected', this.setData());
		}
	}
}
</script>